import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { TESTIDS } from "../lib/testids";
import { Button } from "../components/app/theme";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/briefing" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      toast.success("Connexion réussie", { duration: 1500 });
      nav("/briefing");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Échec de connexion");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="th-scope min-h-screen grid md:grid-cols-2"
      style={{ backgroundColor: "var(--th-bg)" }}
    >
      {/* Panneau gauche : identité produit */}
      <div
        className="hidden md:flex flex-col justify-between p-12"
        style={{ backgroundColor: "var(--th-navy)", color: "#ffffff" }}
      >
        <div>
          <div className="text-xs mb-3" style={{ color: "rgba(255,255,255,0.55)" }}>
            Pilote Commercial
          </div>
          <h1
            className="mt-8 leading-[1.02]"
            style={{
              fontFamily: "var(--th-font-sans)",
              fontSize: 52,
              fontWeight: 500,
              letterSpacing: "-0.015em",
            }}
          >
            Où est<br />l&apos;argent<br />qui dort&nbsp;?
          </h1>
        </div>
        <div
          className="text-sm max-w-md pl-4"
          style={{
            color: "rgba(255,255,255,0.7)",
            borderLeft: "2px solid rgba(255,255,255,0.2)",
          }}
        >
          Une lecture claire de vos propales commerciales envoyées et de vos clients silencieux —
          pour savoir chaque matin quoi faire, dans l&apos;ordre, pour récupérer du CA.
        </div>
        <div className="text-xs" style={{ color: "rgba(255,255,255,0.4)" }}>
          V1 démo
        </div>
      </div>

      {/* Formulaire */}
      <div
        className="flex items-center justify-center p-6"
        style={{ backgroundColor: "var(--th-surface)" }}
      >
        <form onSubmit={submit} className="w-full max-w-sm space-y-6">
          <div>
            <div className="th-section-label">Accès</div>
            <h2
              className="mt-2"
              style={{
                fontFamily: "var(--th-font-sans)",
                fontSize: 27,
                fontWeight: 500,
                color: "var(--th-text)",
                letterSpacing: "-0.005em",
              }}
            >
              Connexion
            </h2>
            <p className="mt-2 text-sm" style={{ color: "var(--th-text-2)" }}>
              Entrez votre email et mot de passe.
            </p>
          </div>

          <div className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email" style={{ color: "var(--th-text)" }}>Email</Label>
              <Input
                id="email"
                type="email"
                data-testid={TESTIDS.loginUser}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
                autoComplete="username"
                placeholder="ex : marie@example.com"
                style={{
                  borderColor: "var(--th-border-strong)",
                  borderRadius: 8,
                  backgroundColor: "var(--th-surface)",
                }}
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password" style={{ color: "var(--th-text)" }}>Mot de passe</Label>
              <Input
                id="password"
                data-testid={TESTIDS.loginPass}
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
                style={{
                  borderColor: "var(--th-border-strong)",
                  borderRadius: 8,
                  backgroundColor: "var(--th-surface)",
                }}
              />
            </div>
          </div>

          <Button
            as="button"
            type="submit"
            data-testid={TESTIDS.loginSubmit}
            disabled={loading}
            variant="primary"
            className="w-full h-11"
          >
            {loading ? "Connexion…" : "Se connecter"}
          </Button>

          <div
            className="text-xs pt-4"
            style={{
              color: "var(--th-text-3)",
              borderTop: "1px solid var(--th-border)",
            }}
          >
            Pas encore d&apos;accès&nbsp;? Demandez à l&apos;administrateur de créer votre compte.
          </div>
        </form>
      </div>
    </div>
  );
}
